<template>
  <Form @submit="onSubmit">
    <div>
      <div>
        <div id="fill-the-blank" class="flex flex-wrap items-baseline w-full text-lg leading-loose text-gray-900 dark:text-white">
          <div class="inline pr-1" v-for="segment in fillSentence" :key="segment">
            <div class="inline" v-if="!segment.includes('_____')">{{ segment }}</div>
            <div class="inline" v-else>
              <input
                type="text"
                size="5"
                name="filledItem"
                autocomplete="off"
                class="px-1 py-0 text-lg bg-yellow-100 border-0 flex-inline focus:outline-none focus:ring-transparent dark:bg-gray-600"
                @input="resizeInput($event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="errorMessage.length > 0" class="mt-1 text-sm text-red-500">{{ errorMessage }}</div>

    <TaskSubmitButton :cta="'Submit'" :correct="answer.correct" @skip="$emit('skip', $event)" />
  </Form>
</template>

<script>
import { Form } from "vee-validate";
import TaskSubmitButton from "../task/TaskSubmitButton.vue";
import isEqual from "lodash.isequal";
import { computed, ref } from "vue";

export default {
  components: {
    Form,
    TaskSubmitButton,
  },
  props: {
    solution: Array,
    options: Array,
  },
  setup(props, { emit }) {
    const errorMessage = ref("");
    const answer = ref({
      item: null,
      correct: null,
    });

    function onSubmit() {
      // validation
      document.querySelectorAll('input[type="text"]').forEach((item) => {
        if (!item.value) {
          return (errorMessage.value = "Please fill all fields");
        } else {
          return (errorMessage.value = "");
        }
      });

      if (errorMessage.value.length == 0) {
        // Get answers
        const arr = Array.from(document.querySelectorAll('input[type="text"]'));
        const answersArr = arr.map(function (input) {
          return input.value.replace(/\s+/g, "").toLowerCase();
        });

        const lowerCaseSolution = props.solution.map((v) => v.replace(/\s+/g, "").toLowerCase());

        // IMPROVE add hamming distance or other spelling mistake handler
        const correct = isEqual(answersArr, lowerCaseSolution) ? true : false;

        answer.value = {
          item: answersArr[0],
          correct: correct,
        };

        emit("answer", answer.value);
      }
    }
    function resizeInput(input) {
      const defaultSize = 5;
      const currentSize = parseInt(input.target.getAttribute("size"));

      // Expand/shrink input size
      if (input.target.value.length > currentSize) {
        input.target.setAttribute("size", currentSize + 1);
      } else if (currentSize >= defaultSize) {
        input.target.setAttribute("size", currentSize - 1);
      }

      // user clears input completely
      if (input.target.value.length < defaultSize) {
        input.target.setAttribute("size", defaultSize);
      }
    }

    const fillSentence = computed(() => {
      const options = props.options[0];
      return options.split(" ");
    });

    return { errorMessage, answer, onSubmit, resizeInput, fillSentence };
  },
};
</script>
